export default __webpack_public_path__ + "static/media/bigBannerBr.ee735dd7.png";